import React, { createContext, useState, useRef, useEffect, } from "react";
import AgentService from "core/api/AgentService";
import { useAuth0 } from "react-auth0-spa";

export const UserContext = createContext({ userData: { status: "Offline" }, setUserData: () => { }, setUserStatus: () => { }, prevUserStatus: "Offline", userStatusRef: null })

export const UserProvider = ({ children }) => {
    const [userData, setUserData] = useState({ status: "Offline" });
    const [prevUserStatus, setPrevUserStatus] = useState("Offline")
    const userStatusRef = useRef(userData.status)
    const { user, userPermissions } = useAuth0()

    const setUserStatus = (status) => {
        setUserData((userData) => { setPrevUserStatus(userData.status); return { ...userData, status: status } });
    }

    const userHasAnyPermissions = (requiredPermissions = []) => {
        return requiredPermissions.some(p => userPermissions?.includes(p));
    }


    useEffect(() => {
        userStatusRef.current = userData.status
    }, [userData.status])

    useEffect(() => {
        async function fetchData() {
            const response = await AgentService.getUserStatus(user.email)
            setUserData({ ...userData, status: response ?? "Offline" })
        }

        if (userPermissions && userHasAnyPermissions(["all:agent", "admin"])) { 
            fetchData();
        }

    }, [])


    return (
        <UserContext.Provider value={{ userData, setUserData, setUserStatus, prevUserStatus, userStatusRef, userHasAnyPermissions }}>
            {children}
        </UserContext.Provider>
    )
}